// extracted by mini-css-extract-plugin
export default {"time_needle_box_overlay":"needleOverlayBox_time_needle_box_overlay__56qlh"};